// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPageLedgerReportDto } from './IPageLedgerReportDto';
import {
    IPageLedgerReportDtoFromJSON,
    IPageLedgerReportDtoFromJSONTyped,
    IPageLedgerReportDtoToJSON,
    IPageLedgerReportDtoToJSONTyped,
} from './IPageLedgerReportDto';

/**
 * 
 * @export
 * @interface IAccountCloseDetailsReportDto
 */
export interface IAccountCloseDetailsReportDto {
    /**
     * 
     * @type {string}
     * @memberof IAccountCloseDetailsReportDto
     */
    account?: string;
    /**
     * 
     * @type {string}
     * @memberof IAccountCloseDetailsReportDto
     */
    account_number?: string;
    /**
     * 
     * @type {string}
     * @memberof IAccountCloseDetailsReportDto
     */
    type?: IAccountCloseDetailsReportDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IAccountCloseDetailsReportDto
     */
    close_date?: string;
    /**
     * 
     * @type {number}
     * @memberof IAccountCloseDetailsReportDto
     */
    our_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountCloseDetailsReportDto
     */
    bank_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountCloseDetailsReportDto
     */
    difference?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountCloseDetailsReportDto
     */
    prior?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountCloseDetailsReportDto
     */
    delta?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountCloseDetailsReportDto
     */
    credit?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountCloseDetailsReportDto
     */
    debit?: number;
    /**
     * 
     * @type {IPageLedgerReportDto}
     * @memberof IAccountCloseDetailsReportDto
     */
    ledgers?: IPageLedgerReportDto;
}

/**
* @export
* @enum {string}
*/
export enum IAccountCloseDetailsReportDtoTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}


/**
 * Check if a given object implements the IAccountCloseDetailsReportDto interface.
 */
export function instanceOfIAccountCloseDetailsReportDto(value: object): value is IAccountCloseDetailsReportDto {
    return true;
}

export function IAccountCloseDetailsReportDtoFromJSON(json: any): IAccountCloseDetailsReportDto {
    return IAccountCloseDetailsReportDtoFromJSONTyped(json, false);
}

export function IAccountCloseDetailsReportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAccountCloseDetailsReportDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account': json['account'] == null ? undefined : json['account'],
        'account_number': json['account_number'] == null ? undefined : json['account_number'],
        'type': json['type'] == null ? undefined : json['type'],
        'close_date': json['close_date'] == null ? undefined : json['close_date'],
        'our_balance': json['our_balance'] == null ? undefined : json['our_balance'],
        'bank_balance': json['bank_balance'] == null ? undefined : json['bank_balance'],
        'difference': json['difference'] == null ? undefined : json['difference'],
        'prior': json['prior'] == null ? undefined : json['prior'],
        'delta': json['delta'] == null ? undefined : json['delta'],
        'credit': json['credit'] == null ? undefined : json['credit'],
        'debit': json['debit'] == null ? undefined : json['debit'],
        'ledgers': json['ledgers'] == null ? undefined : IPageLedgerReportDtoFromJSON(json['ledgers']),
    };
}

export function IAccountCloseDetailsReportDtoToJSON(json: any): IAccountCloseDetailsReportDto {
    return IAccountCloseDetailsReportDtoToJSONTyped(json, false);
}

export function IAccountCloseDetailsReportDtoToJSONTyped(value?: IAccountCloseDetailsReportDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account': value['account'],
        'account_number': value['account_number'],
        'type': value['type'],
        'close_date': value['close_date'],
        'our_balance': value['our_balance'],
        'bank_balance': value['bank_balance'],
        'difference': value['difference'],
        'prior': value['prior'],
        'delta': value['delta'],
        'credit': value['credit'],
        'debit': value['debit'],
        'ledgers': IPageLedgerReportDtoToJSON(value['ledgers']),
    };
}

